import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.47826 8.86957C3.60835 8.86957 2.08696 7.34817 2.08696 5.47826C2.08696 3.60835 3.60835 2.08696 5.47826 2.08696C7.34817 2.08696 8.86957 3.60835 8.86957 5.47826C8.86957 7.34817 7.34817 8.86957 5.47826 8.86957ZM11.6943 10.2188L10.0174 8.54191C10.6101 7.66696 10.9565 6.61252 10.9565 5.47826C10.9565 2.45739 8.49913 0 5.47826 0C2.45739 0 0 2.45739 0 5.47826C0 8.49913 2.45739 10.9565 5.47826 10.9565C6.61252 10.9565 7.66696 10.6101 8.54191 10.0174L10.2188 11.6943C10.4223 11.8983 10.6894 12 10.9565 12C11.2237 12 11.4908 11.8983 11.6943 11.6943C12.1017 11.2868 12.1017 10.6263 11.6943 10.2188Z"
	})]
});
const ForwardRef = forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
